import { render, staticRenderFns } from "./aiDetail.vue?vue&type=template&id=3b1d6fe4&"
import script from "./aiDetail.vue?vue&type=script&lang=js&"
export * from "./aiDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1d6fe4')) {
      api.createRecord('3b1d6fe4', component.options)
    } else {
      api.reload('3b1d6fe4', component.options)
    }
    module.hot.accept("./aiDetail.vue?vue&type=template&id=3b1d6fe4&", function () {
      api.rerender('3b1d6fe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/detail/aiDetail.vue"
export default component.exports